<template>
  <div class="wrapper">
    <share-modal
      v-if="isShare"
      :pharmacy="selectedPharmacy"
      @onClose="closeShareModal"
    />
    <pharmacy-detail 
      v-if="isDetail"
      :propsPharmacy="selectedPharmacy"
      @onClose="closePharmacyDetailView"
      @viewMaps="viewDetailMaps"
    />
    <div v-show="!isDetail" class="wrapper">
      <div v-if="isListView" class="page">
        <img v-if="isBackButtonActive" @click="back" style="width: 22px; cursor: pointer;" src="../assets/arrow_back.png" class="back-button" />
    
        <list-search-bar 
          @onSearchByLocation="searchByLocation"
          @onSearch="search"
          @modeChange="modeChange"
          @viewMaps="viewMapsNotSelected"
          :preKeyword="keyword"
          :isMapSearch="isMapSearch"
          :preLatitude="baseLatitude"
          :preLongitude="baseLongitude"
          :zoomLevel="zoomLevel"
        />
        <list 
          @modeChange="modeChange"
          @viewMaps="viewMaps"
          :zoomLevel="zoomLevel"
          @viewDetail="pharmacyDetailView"
          @share="share"
        />
        
      </div>
      <div v-if="!isListView" class="page">
        <maps 
          :baseLongitude="baseLongitude"
          :baseLatitude="baseLatitude"
          :preKeyword="keyword"
          :selectedPharmacy="selectedPharmacy"
          :savedZoomLevel="zoomLevel"
          @onSearch="search2"
          @onSearchMap="search3"
          @changeView="modeChange"
          @viewDetail="pharmacyDetailView"
          @share="share"
        />

      </div>
    </div>
  </div>    
</template>  
  <script>
// max height 600px


import axios from 'axios';
import List from "@/components/organisms/map/List";
import ListSearchBar from '@/components/molecules/maps/ListSearchBar';
import {mapState} from 'vuex';
import Constant from '@/constant';
import Maps from '@/components/organisms/map/Maps';
import PharmacyDetail from '@/page/PharmacyDetail';
import ShareModal from '@/components/modals/ShareModal';

  export default {
    name: "NaverMap",
    computed: mapState(['sharedPharmacy', 'pharmacyMedicineFilter', 'pharmacyUserLocation']),
    components: {
      List,
      ListSearchBar,
      Maps,
      PharmacyDetail,
      ShareModal
    },
    data() {
      return {
        isPopupVisible: false, // 팝업 상태
        baseLongitude: 127.0276642,  //솔닥 주소
        baseLatitude: 37.5191166,
        list: [],
        selectedMarker: null, // 선택된 마커 정보
        selectedPharmacy: null,
        isViewMedicineList: false,
        map: null,
        isListView: true,
        keyword: '',
        markers: [],
        isMapSearch: false,
        zoomLevel: 18,
        isDetail: false,
        isShare: false,
        isBackButtonActive: false,
        saveScroll: 0,
        // 약품 필터가 바뀌면 같은 조건으로 다시 검색하기 위해 마지막 검색을 기억
        lastSearch: null,
        // 응답 순서가 뒤바뀌어도 마지막 요청 결과만 반영
        searchSeq: 0
      };
    },
    mounted() {
      // mapstate에 id가 있다면, 확인 후 없앰
      // list에 추가후 select
      if(this.$route.query.isback === 'true')
      {
        this.isBackButtonActive = true;
      }
      // 
      if(this.sharedPharmacy)
      {
        this.selectedPharmacy = this.sharedPharmacy;
        this.baseLatitude = this.selectedPharmacy.latitude;
        this.baseLongitude = this.selectedPharmacy.longitude;
        this.$store.commit(Constant.SET_SHARED_PHARMACY, {
            pharmacy: null
        })
        this.$store.commit(Constant.SEARCH_DIABETES_PHARMACY, {
            pharmacies: [this.selectedPharmacy]
        })
        this.search4("", this.selectedPharmacy.latitude, this.selectedPharmacy.longitude)
        this.isListView = false;
        // shared phamacy delete 
      }
    },
     methods: {
      back: function()
      {
        this.$router.push({path: '/home'})
      },
      closeShareModal: function()
      {
        console.log("closeShareModal")
        this.selectedPharmacy = null
        this.isShare = false;
      },
      share: function(pharmacy)
      {
        this.selectedPharmacy = pharmacy
        this.isShare = true;
      },
      closePharmacyDetailView: function()
      {        
        this.selectedPharmacy = null;
        this.isDetail = false;
        this.visible = true;
        this.$nextTick(() => {
          this.restoreScroll();
        });
        
      },
      viewDetailMaps: function(pharmacy)
      {
        this.selectedPharmacy = pharmacy
        this.isDetail = false;
        this.isListView = false;
      },
      pharmacyDetailView: function(pharmacy)
      {
        //scroll 위치 저장 
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        this.saveScroll = scrollY;
        console.log("[pharmacy]: " + JSON.stringify(pharmacy))
        this.selectedPharmacy = pharmacy;
        this.isDetail = true;
      },
      restoreScroll() {
        window.scrollTo({
          top: this.saveScroll,
          behavior: 'auto'
        });
        this.saveScroll = 0;
      },
      modeChange: function(keyword, zoomLevel)
      {

        this.keyword = keyword;
        this.zoomLevel = zoomLevel;
        this.isListView = !this.isListView;

        if(this.isListView)
        {
          this.$nextTick(() => {
            this.restoreScroll();
          });
        
        }

      },
      viewMapsNotSelected: function(info)
      {
        if(this.isListView)
        {
          const scrollY = window.scrollY || document.documentElement.scrollTop;
          this.saveScroll = scrollY;
        }
        this.zoomLevel = 10;
        this.baseLongitude = info.longitude;  //솔닥 주소
        this.baseLatitude = info.latitude;
        this.selectedPharmacy = null;
        this.isListView = false;
      },
      viewMaps: function(info)
      {
        if(this.isListView)
        {
          const scrollY = window.scrollY || document.documentElement.scrollTop;
          this.saveScroll = scrollY;
        }

        this.baseLongitude = info.longitude;  //솔닥 주소
        this.baseLatitude = info.latitude;
        this.selectedPharmacy = info;
        this.isListView = false;
      },
      searchByLocation: function(keyword, city, subcity)
      {
        this.selectedPharmacy = null;
        this.keyword = '';
        this.fetchPharmacyByLocation(keyword, city, subcity)
      },
      search: function(query, latitude, longitude)
      {
        this.selectedPharmacy = null;
        this.keyword = '';
        this.baseLatitude = latitude;
        this.baseLongitude = longitude;
        this.fetchPharmacy(query);
      },
      search2: function(query, latitude, longitude)
      {
        console.log("search2")
        this.selectedPharmacy = null;
        this.baseLatitude = latitude;
        this.baseLongitude = longitude;
        this.keyword = query;
        this.isMapSearch = true;
        this.fetchPharmacy(query, true);
      },
      search3: function(query, latitude, longitude)
      {
        console.log("search3")
        this.selectedPharmacy = null;
        this.baseLatitude = latitude;
        this.baseLongitude = longitude;
        this.keyword = query;
        this.isMapSearch = true;
        this.fetchPharmacy(query, false);
      },
      search4: function(query, latitude, longitude)
      {
        this.baseLatitude = latitude;
        this.baseLongitude = longitude;
        this.keyword = query;
        this.isMapSearch = true;
        this.fetchPharmacy(query, false);
      },
      getLocation: function()
      {
        if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                  (position) => {
                      const lat = position.coords.latitude;
                      const lng = position.coords.longitude;
                      console.log("현재 위치:", lat, lng);
                      this.baseLatitude = lat;
                      this.baseLongitude = lng;
                      this.fetchPharmacy("empty_keyword");  // 전체 검색 
                  },
                  (error) => {
                      console.error("위치 정보를 가져올 수 없습니다.", error);
                  }
              );
          } else {
              console.error("이 브라우저에서는 위치 정보를 사용할 수 없습니다.");
          }
      },
      // 약품 필터 구간. 여러 개는 쉼표로 구분하고 모두 보유한 약국만 나온다(AND). 선택이 없으면 null
      medicinesSegment: function()
      {
        const medicines = this.pharmacyMedicineFilter.insulins.slice();
        if(this.pharmacyMedicineFilter.baqsimi)
        {
          // 부분 일치라 바크시미나잘스프레이 보유 약국도 포함된다
          medicines.push('바크시미');
        }
        return medicines.length > 0 ? medicines.join(',') : null;
      },
      // 한글, 쉼표가 들어가므로 경로 구간마다 인코딩
      pharmacyUrl: function(segments)
      {
        const medicines = this.medicinesSegment();
        if(medicines !== null)
        {
          segments = segments.concat([medicines]);
        }
        return `${process.env.API_DB_ROOT}/diabetes/pharmacy/` + segments.map((segment) => encodeURIComponent(String(segment))).join('/');
      },
      fetchPharmacyByLocation: async function(query, city, subcity)
      {
        if(query === "")
        {
          query = "empty_keyword";
        }
        if(subcity === "전체")
        {
          subcity = "empty_keyword"
        }
        this.lastSearch = { type: 'location', query, city, subcity };

        const seq = ++this.searchSeq;
        const url = this.pharmacyUrl(['location', query, city, subcity]);
        // 현재 위치를 확보했으면 좌표를 붙여 가까운 순으로 정렬. 없으면 쿼리 없이 호출
        const params = this.pharmacyUserLocation === null ? {} : {
          latitude: this.pharmacyUserLocation.latitude,
          longitude: this.pharmacyUserLocation.longitude
        };
        const response = await axios.get(url, { params });
        if(seq !== this.searchSeq)
        {
          return;
        }
        this.$store.commit(Constant.SEARCH_DIABETES_PHARMACY, {
            pharmacies: response.data.data
        })
        
      },
      fetchPharmacy: async function(query, change)
      {    
        if(query === "")
        {
          query = "empty_keyword";
        }
        this.lastSearch = { type: 'search', query };

        const seq = ++this.searchSeq;
        const url = this.pharmacyUrl(['search', query, this.baseLongitude, this.baseLatitude, 20]);
        const response = await axios.get(url);
        if(seq === this.searchSeq)
        {
          this.$store.commit(Constant.SEARCH_DIABETES_PHARMACY, {
              pharmacies: response.data.data
          })
        }

        if(change)
        {
          this.isListView = !this.isListView;
        }
      },
      // 약품 필터 변경 시 마지막 검색어, 지역(또는 위치) 그대로 다시 검색
      searchAgainWithMedicineFilter: function()
      {
        if(this.lastSearch === null)
        {
          return;
        }
        if(this.lastSearch.type === 'location')
        {
          this.fetchPharmacyByLocation(this.lastSearch.query, this.lastSearch.city, this.lastSearch.subcity);
        }
        else
        {
          this.fetchPharmacy(this.lastSearch.query, false);
        }
      },
      initMap: async function  () {
        // await this.fetchPharmacy("empty_keyword");  // 전체 검색 
          this.map = new naver.maps.Map("map", {
               zoom: 18,
               center: new naver.maps.LatLng(this.baseLatitude, this.baseLongitude),
               zoomControl: true,
               zoomControlOptions: {
               position: naver.maps.Position.TOP_LEFT,
               style: naver.maps.ZoomControlStyle.SMALL
               }
          });
          this.markers = []
          var data = this.list;

          for (let i = 0, ii = data.length; i < ii; i++) {
               const spot = data[i];
               
               const latlng = new naver.maps.LatLng(spot.latitude, spot.longitude);
      
               const marker = new naver.maps.Marker({
                    position: latlng,
                    map: this.map,
                    icon: {
                      url: 'https://baro.soldoc.co.kr/poi.png', // 마커 이미지 경로
                      size: new naver.maps.Size(29, 29), // 이미지 크기
                      scaledSize: new naver.maps.Size(29, 29),
                      origin: new naver.maps.Point(0, 0), // 이미지 원점
                      anchor: new naver.maps.Point(14.5, 29) // 마커 기준 위치 (하단 중앙 기준이면 이렇게)
                  }
               });
               
               // 마커 클릭 이벤트 (바텀 팝업 표시)
               naver.maps.Event.addListener(marker, "click", () => {
                this.isPopupVisible = true;

                this.map.setCenter(marker.getPosition());
                this.map.setZoom(18); // 원하는 줌 레벨
                this.selectedMarker = data[i]

                  marker.setIcon({
                    url: "../assets/card.png", // 선택된 마커 이미지                    
                    size: new naver.maps.Size(50, 50), // 선택된 경우 크기 조정 가능
                    scaledSize: new naver.maps.Size(50, 50),
                    anchor: new naver.maps.Point(25, 50)
                  });
                // selected marker
               });
      
               this.markers.push(marker);
          }

          naver.maps.Event.addListener(this.map, "click", (event) => {
              this.isPopupVisible = false
          });

          naver.maps.Event.addListener(this.map, "dragstart", () => {
            this.isPopupVisible = false
          });


        var htmlMarker1 = {
              content: '<div style="cursor:pointer;width:44px;height:44px;line-height:42px;font-size:20px;color:white;text-align:center;font-weight:600;background:rgba(24, 79, 161, 0.83);border-radius: 50%;"></div>',
              size: N.Size(40, 40),
              anchor: N.Point(20, 20)
        }

        var markerClustering = new window.MarkerClustering({
            minClusterSize: 2,
            maxZoom: 13,
            map: this.map,
            markers: markers,
            disableClickZoom: false,
            gridSize: 120,
            icons: [htmlMarker1],
            indexGenerator: [10],
            stylingFunction: function(clusterMarker, count) {
                $(clusterMarker.getElement()).find('div:first-child').text(count);
            }
        });
      },  
    },
    watch: {
      // 스토어 값은 바크시미를 체크/해제할 때, 인슐린 모달이 선택이 바뀐 채로 닫힐 때만 바뀐다
      // 목록, 지도 어디서 바꿔도 같은 값이라 한 곳에서 처리
      pharmacyMedicineFilter: function()
      {
        this.searchAgainWithMedicineFilter();
      }
    },
  };
  </script>
  
  <style scoped>
  /* 바텀 팝업 스타일 */
  .bottom-popup {
    position: fixed;
    bottom: -1000px; /* 초기 상태: 화면 아래에 숨김 */
    left: 0;
    width: 100%;
    background: white;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.2);
    transition: bottom 0.3s ease-in-out;
    border-radius: 15px 15px 0 0;
    z-index: 100;

  }
  
  /* 팝업이 보일 때 */
  .bottom-popup.show {
    bottom: 0; /* 화면에 표시 */
  }
  
  /* 팝업 내부 내용 */
  .popup-content {
    padding: 20px;
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  
  /* 닫기 버튼 */
  .close-btn {
    background: #ff5a5f;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
  }

  .close-button {
    opacity: 0;
    width: 100%;
    height: 100vh;
    background: black;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
  }

  .back-button {
    position: absolute;
    left: 16px;
    top: 16px;
    cursor: pointer;
  }
  .wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .page {
    position: relative;
      width: 100%;
      background: var(--Gray-20, #F3F5F8);
  }
    /* layout */
    @media (min-width: 600px) {
      .page {
          width: 600px;
      }
    }
  </style>


// WEBPACK FOOTER //
// src/page/Pharmacy.vue